import React, { Component } from 'react';
import classNames from 'classnames';
import './Divider.css';

export default class Divider extends Component {
	render() {
		let classes = classNames('g-divider', { vertical: this.props.vertical });
		return <div className={classes} />;
	}
}



// WEBPACK FOOTER //
// ./src/components/divider/Divider.jsx